import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';

export function setSentryUser(user: { id: string; email: string; name: string }) {
    try {
        Sentry.setUser({
            id: user.id,
            email: user.email,
            username: user.name,
        });
    } catch (e) { /* silent */ }

    try {
        SentryVue.setUser({
            id: user.id,
            email: user.email,
            username: user.name,
        });
    } catch (e) { /* silent */ }
}

export function clearSentryUser() {
    Sentry.setUser(null);
    SentryVue.setUser(null);
}